import { toast } from 'react-toastify';

import { getCountryByCode, getRegionsByCountryCode } from 'general/countryRegion';
import { AppCompany } from 'types';

import { IUser } from 'modules/auth-session';

export const copyToClipboard = ({ text = '', message = '' }: { text: string; message?: string }) => {
  navigator.clipboard.writeText(text);
  if (message) toast.success(message);
};

export const capitalize = (s: string) => (s ? s[0].toUpperCase() + s.slice(1) : s);

export const getGeoLocation = ({ countryCode, regionCode }: { countryCode: string; regionCode?: string }) => {
  const country = getCountryByCode(countryCode)?.label || null;
  let region = null;
  if (country && regionCode) {
    region = getRegionsByCountryCode(countryCode).filter((reg) => reg.code === regionCode)[0]?.label || null;
  }

  return { country, region, location: `${country}${region ? `, ${region}` : ''}` };
};

export const canAccessToCompany = (company: AppCompany, currentUser: IUser) => {
  if (currentUser.hasAdminAccess) return true;

  return currentUser.company?.id === company.id || currentUser.admin_companies.some(({ id }) => id === company.id);
};

export const debounce = (func: (...args: any[]) => void, delay: number) => {
  let timeout: NodeJS.Timeout;
  return (...args: any[]) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
};

export const formatFileSize = (bytes: number, decimals: number = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};
